module.exports = __webpack_public_path__ + "img/Hand_31_05_17.be93e984.png";